import { Link } from "react-router-dom";
import { announcements } from "@/mocks/homeData";

export default function AnnouncementsSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              最新公告
            </h2>
            <p className="text-foreground-600 text-sm">关注爱情岛网址最新动态</p>
          </div>
          <Link
            to="/category/latest-url"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {announcements.map((ann) => (
            <Link
              key={ann.id}
              to={`/category/latest-url`}
              className="group p-5 rounded-2xl bg-background-50 hover:bg-background-50/80 transition-all duration-200 flex gap-4 cursor-pointer"
            >
              <div className="flex-shrink-0 pt-1">
                <span
                  className={`w-2.5 h-2.5 rounded-full block ${
                    ann.isNew ? "bg-primary-500 animate-pulse" : "bg-foreground-300"
                  }`}
                ></span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  {ann.isNew && (
                    <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      最新
                    </span>
                  )}
                  <span className="text-xs text-foreground-500">{ann.date}</span>
                </div>
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 text-sm md:text-base">
                  {ann.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2">{ann.summary}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-6 sm:hidden">
          <Link
            to="/category/latest-url"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部公告
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}